export { default as ProductTile } from './productTile'
export * from './colorPicker'
export * from './quickAdd'



// WEBPACK FOOTER //
// ./src/modules/productTile/index.js